import React, { useEffect, useState } from "react";
import { Truck, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/wolfApi";

export const MyOrdersPanel = () => {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/merch/my-orders").then((r) => setOrders(r.data.orders)).catch(() => {});
  }, []);

  if (!orders || orders.length === 0) return null;

  return (
    <div className="mt-6 bg-[#111111] border border-white/10 p-6" data-testid="my-orders-panel">
      <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-3">— Your Orders</p>
      <ul className="space-y-3" data-testid="my-orders-list">
        {orders.slice(0, 5).map((o) => (
          <li key={o.session_id} className="border border-white/8 bg-[#0d0d0d] p-3">
            <div className="flex items-center justify-between">
              <span className="font-display text-[#D4AF37]">${(o.amount || 0).toFixed(2)} AUD</span>
              <span className="text-[10px] text-white/40">{(o.created_at || "").slice(0, 10)}</span>
            </div>
            <p className="text-xs text-white/70 mt-1.5">{(o.items_summary || []).join(" · ")}</p>
            <p className="mt-2">
              {o.shipped_at ? (
                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">
                  <Truck size={12} /> Shipped {(o.shipped_at || "").slice(0, 10)}
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-white/45">
                  <CheckCircle2 size={12} /> Confirmed — preparing your gear
                </span>
              )}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};
